<template>
    <MaintenanceView v-if="authStore.maintenanceMode" />
    <template v-else>
        <Announcer />
        <RouterView v-slot="{ Component, route }">
            <component :is="getLayoutComponent(route)">
                <Transition name="scale-blur">
                    <div class="route-anim relative flex h-full flex-col" :key="route.matched[0]?.path">
                        <component :is="Component" />
                    </div>
                </Transition>
            </component>
        </RouterView>
        <ToastContainer />
    </template>
</template>

<script>
import { RouterView } from 'vue-router'
import AppLayout from '@/layouts/AppLayout.vue'
import GameLayout from '@/layouts/GameLayout.vue'
import ToastContainer from '@/components/ui/ToastContainer.vue'
import MaintenanceView from '@/views/MaintenanceView.vue'
import Announcer from '@/components/announcer/Announcer.vue'
import { useAuthStore } from '@/stores/auth.js'

export default {
    name: 'App',
    components: { RouterView, AppLayout, GameLayout, ToastContainer, MaintenanceView, Announcer },
    setup() {
        const authStore = useAuthStore()
        return { authStore }
    },
    data() {
        return {
            unsubscribeBridge: null,
        }
    },
    methods: {
        getLayoutComponent(route) {
            return route.meta?.layout === 'GameLayout' ? GameLayout : AppLayout
        },
    },
    mounted: function () {
        this.unsubscribeBridge = this.$bridge.on('notification.show', () => {
            const imageUrl = new URL('@/assets/images/playerPlaceholder.png', import.meta.url).href
            this.$toast('Swift', 5000, 'Received a notifcation from <b>Swift</b>!', imageUrl)
        })

        setTimeout(() => {
            this.$bridge.emit('gameon.ready', { reason: 'started' })
        }, 500)

        this.$analytics.trackEvent('app_open', { platform: this.$bridge.platform })
    },
    beforeUnmount() {
        if (this.unsubscribeBridge) {
            this.unsubscribeBridge()
            this.unsubscribeBridge = null
        }
    },
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>

<style>
.scale-blur-enter-active,
.scale-blur-leave-active {
    transition:
        opacity 0.4s ease,
        transform 0.4s ease,
        filter 0.4s ease;
}

/* Take the leaving page out of flow so the entering page doesn't get
   pushed below it while both are in the DOM during the crossfade. */
.scale-blur-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
}

.scale-blur-enter-from {
    opacity: 0;
    transform: scale(0.96);
    filter: blur(8px);
}

.scale-blur-leave-to {
    opacity: 0;
    transform: scale(1.03);
    filter: blur(8px);
}
</style>
